// Mock data for AlphaPro Genetics clone (light blue-white theme)
// All data is mocked - no real backend

export const CATEGORIES = [
  { id: 'all', name: 'Wszystko', slug: 'wszystko' },
  { id: 'inj', name: 'Sterydy iniekcyjne', slug: 'sterydy-iniekcyjne' },
  { id: 'tab', name: 'Sterydy tabletkowe', slug: 'sterydy-tabletkowe' },
  { id: 'pep', name: 'Peptydy & HGH', slug: 'peptydy-hgh' },
  { id: 'sup', name: 'Suplementy & PCT', slug: 'suplementy-pct' },
  { id: 'pot', name: 'Leki na potencję', slug: 'leki-na-potencje' }
];

const IMG = 'https://alphapro-genetics.pl/wp-content/uploads';

export const PRODUCTS = [
  {
    id: 'trenbolone-enanthate',
    name: 'Trenbolone Enanthate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 200mg/ml',
    badge: 'Hit',
    image: `${IMG}/2026/04/Trenbolone-Enanthate-500x500.png`,
    color: '#2563EB',
    short: 'Silny anaboliczny i androgenny ester trenbolonu o przedłużonym działaniu.',
    description: 'Trenbolone Enanthate to jeden z najsilniejszych sterydów anabolicznych dostępnych na rynku. Charakteryzuje się 5-krotnie silniejszym działaniem od testosteronu. Powolne uwalnianie estru pozwala na utrzymanie stabilnego poziomu hormonu we krwi przy podaniu 2x w tygodniu.',
    benefits: ['Ogromny przyrost suchej masy', 'Spalanie tkanki tłuszczowej', 'Wzrost siły i wytrzymałości', 'Brak retencji wody']
  },
  {
    id: 'trenbolone-acetate',
    name: 'Trenbolone Acetate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 100mg/ml',
    badge: 'Top',
    image: `${IMG}/2026/04/Trenbolone-Acetate-500x500.png`,
    color: '#1D4ED8',
    short: 'Najszybciej działający ester trenbolonu, idealny na cykle redukcyjne.',
    description: 'Trenbolone Acetate to krótko działający ester trenbolonu z okresem półtrwania ok. 1-2 dni. Wymaga częstszych iniekcji, ale efekty są niemal natychmiastowe.',
    benefits: ['Szybkie efekty wizualne', 'Twardość mięśni', 'Redukcja tłuszczu', 'Brak aromatyzacji']
  },
  {
    id: 'testosterone-enanthate',
    name: 'Testosterone Enanthate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 250mg/ml',
    badge: null,
    image: `${IMG}/2026/04/Testosterone-Enanthate-500x500.png`,
    color: '#3B82F6',
    short: 'Klasyczny testosteron o długim działaniu - baza każdego cyklu masowego.',
    description: 'Testosterone Enanthate to ester testosteronu o długim okresie półtrwania (5-7 dni). Idealna baza dla początkujących i zaawansowanych użytkowników.',
    benefits: ['Solidny przyrost masy', 'Wzrost libido i siły', 'Dobra regeneracja', 'Stabilny poziom hormonu']
  },
  {
    id: 'testosterone-propionate',
    name: 'Testosterone Propionate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 100mg/ml',
    badge: null,
    image: `${IMG}/2026/04/Testosterone-Propionate-500x500.png`,
    color: '#3B82F6',
    short: 'Najkrótszy ester testosteronu - szybkie działanie i mała retencja wody.',
    description: 'Krótki ester testosteronu wymagający podawania co 1-2 dni. Najczęściej używany w cyklach redukcyjnych.',
    benefits: ['Szybkie wejście w cykl', 'Brak retencji wody', 'Twarda jakość mięśni', 'Łatwe odstawienie']
  },
  {
    id: 'testosterone-cypionate',
    name: 'Testosterone Cypionate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 250mg/ml',
    badge: null,
    image: `${IMG}/2021/11/Testosterone-Cypionate_-500x500.png`,
    color: '#2563EB',
    short: 'Długi ester testosteronu o profilu zbliżonym do enantatu.',
    description: 'Testosterone Cypionate to długi ester testosteronu popularny zwłaszcza w USA. Działanie i efekty porównywalne do enantatu.',
    benefits: ['Duże przyrosty masy', 'Wzrost siły', 'Poprawa libido', 'Lepsza regeneracja']
  },
  {
    id: 'testosteron-mix',
    name: 'Testosteron Mix (Sustanon)',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 250mg/ml',
    badge: 'Polecamy',
    image: `${IMG}/2026/04/Testosteron-Mix-500x500.png`,
    color: '#1E40AF',
    short: 'Mieszanka 4 estrów testosteronu - stabilny poziom przez cały tydzień.',
    description: 'Sustanon to mieszanka 4 estrów testosteronu (propionian, fenylopropionian, izokapronian, dekanonian). Pozwala utrzymać stabilny poziom hormonu.',
    benefits: ['Stabilny poziom T', 'Szybki start cyklu', 'Długie utrzymanie efektów', 'Wszechstronne zastosowanie']
  },
  {
    id: 'primobolan-enanthate',
    name: 'Primobolan Enanthate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 100mg/ml',
    badge: 'Premium',
    image: `${IMG}/2026/04/Primobolan-Enanthate-500x500.png`,
    color: '#0EA5E9',
    short: 'Łagodny i bezpieczny steryd - klasyk redukcji i podtrzymań.',
    description: 'Methenolone Enanthate to jeden z najbezpieczniejszych anabolików. Nie aromatyzuje i nie powoduje skutków estrogenowych.',
    benefits: ['Łagodny profil', 'Sucha masa', 'Brak aromatyzacji', 'Idealny dla kobiet']
  },
  {
    id: 'nandrolone-pp',
    name: 'Nandrolone Phenylpropionate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 100mg/ml',
    badge: null,
    image: `${IMG}/2026/04/Nandrolone-Phenylpropionate-500x500.png`,
    color: '#0284C7',
    short: 'NPP - szybszy odpowiednik Deca z mniejszą retencją wody.',
    description: 'Krótki ester nandrolonu z okresem półtrwania 4-5 dni. Świetny środek na regenerację stawów i jakościowy przyrost masy.',
    benefits: ['Regeneracja stawów', 'Jakościowy przyrost', 'Mniejsza retencja niż Deca', 'Lepsza kontrola cyklu']
  },
  {
    id: 'masteron-propionate',
    name: 'Masteron Propionate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 100mg/ml',
    badge: null,
    image: `${IMG}/2026/04/Masteron-Propionate-500x500.png`,
    color: '#0369A1',
    short: 'Drostanolon - twardość i estetyka mięśni w okresie redukcji.',
    description: 'Drostanolone Propionate to klasyczny steryd redukcyjny. Daje twardą, suchą jakość mięśni i działa lekko antyestrogennie.',
    benefits: ['Twardość mięśni', 'Działanie antyestrogenne', 'Brak retencji', 'Estetyczna sylwetka']
  },
  {
    id: 'masteron-enanthate',
    name: 'Masteron Enanthate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 200mg/ml',
    badge: null,
    image: `${IMG}/2026/04/Masteron-Enanthate-500x500.png`,
    color: '#0369A1',
    short: 'Długi ester drostanolonu - wygodne 2x w tygodniu.',
    description: 'Długi ester Masterona pozwalający na rzadsze iniekcje przy zachowaniu wszystkich zalet drostanolonu.',
    benefits: ['Twardość i estetyka', 'Rzadsze iniekcje', 'Antyestrogenne działanie', 'Stabilny poziom']
  },
  {
    id: 'boldenone',
    name: 'Boldenone Undecylenate',
    category: 'inj',
    price: 94.99,
    oldPrice: null,
    dosage: '10ml / 250mg/ml',
    badge: null,
    image: `${IMG}/2026/04/Boldenone-Undecylenate-500x500.png`,
    color: '#0891B2',
    short: 'Equipoise - jakościowy przyrost masy i ogromny apetyt.',
    description: 'Boldenone (EQ) to anaboliczny steryd o łagodnym profilu androgennym. Daje powolny, jakościowy przyrost mięśni.',
    benefits: ['Wzrost apetytu', 'Zwiększenie wytrzymałości', 'Jakościowa masa', 'Lepsze ukrwienie']
  },
  {
    id: 'tirzepatide',
    name: 'Tirzepatide',
    category: 'pep',
    price: 94.99,
    oldPrice: null,
    dosage: '10mg',
    badge: 'Nowość',
    image: `${IMG}/2026/04/Tirzepatide-500x500.png`,
    color: '#06B6D4',
    short: 'Najnowocześniejszy peptyd na redukcję tkanki tłuszczowej.',
    description: 'Tirzepatyd to dualny agonista receptorów GIP i GLP-1. Wspiera redukcję wagi i kontrolę glikemii.',
    benefits: ['Skuteczna redukcja wagi', 'Kontrola apetytu', 'Stabilna glikemia', 'Poprawa metabolizmu']
  },
  {
    id: 'ghk-cu',
    name: 'GHK-Cu',
    category: 'pep',
    price: 94.99,
    oldPrice: null,
    dosage: '10mg',
    badge: null,
    image: `${IMG}/2026/04/GHK-Cu-500x500.png`,
    color: '#0EA5E9',
    short: 'Peptyd miedziowy - regeneracja skóry i włosów.',
    description: 'GHK-Cu to peptyd kompleksujący miedź o właściwościach regeneracyjnych i przeciwzapalnych.',
    benefits: ['Regeneracja skóry', 'Wzrost włosów', 'Działanie przeciwzapalne', 'Anti-aging']
  },
  {
    id: 'ghrp-6',
    name: 'GHRP-6',
    category: 'pep',
    price: 94.99,
    oldPrice: null,
    dosage: '10mg',
    badge: null,
    image: `${IMG}/2026/04/Ghrp-6-500x500.png`,
    color: '#0EA5E9',
    short: 'Sekretagog GH - zwiększa wydzielanie hormonu wzrostu.',
    description: 'GHRP-6 stymuluje naturalne uwalnianie hormonu wzrostu z przysadki, dodatkowo zwiększając apetyt.',
    benefits: ['Wzrost wydzielania GH', 'Zwiększony apetyt', 'Lepsza regeneracja', 'Poprawa snu']
  },
  {
    id: 'hgh',
    name: 'Human Growth Hormone (HGH)',
    category: 'pep',
    price: 649.99,
    oldPrice: null,
    dosage: '100IU',
    badge: 'Premium',
    image: `${IMG}/2021/11/4_5915542629549874747-500x500.png`,
    color: '#0284C7',
    short: 'Ludzki hormon wzrostu - klasa farmaceutyczna.',
    description: 'Somatropina o czystości farmaceutycznej. Wspiera regenerację, anti-aging i rekompozycję ciała.',
    benefits: ['Rekompozycja ciała', 'Spalanie tkanki tłuszczowej', 'Anti-aging', 'Regeneracja stawów']
  },
  {
    id: 'high-fragment',
    name: 'HGH Fragment 176-191',
    category: 'pep',
    price: 94.99,
    oldPrice: null,
    dosage: '10mg',
    badge: null,
    image: `${IMG}/2026/04/High-fragment-176-191-500x500.png`,
    color: '#0284C7',
    short: 'Fragment HGH - selektywne spalanie tkanki tłuszczowej.',
    description: 'Fragment cząsteczki HGH odpowiedzialny za lipolizę. Nie wpływa na poziom IGF-1.',
    benefits: ['Selektywna lipoliza', 'Bez wpływu na IGF-1', 'Bez retencji wody', 'Bezpieczny profil']
  },
  {
    id: 'bpc-157',
    name: 'BPC-157',
    category: 'pep',
    price: 99.99,
    oldPrice: 110.00,
    dosage: '10mg',
    badge: 'Promocja',
    image: `${IMG}/2021/11/Bpc-157-500x500.png`,
    color: '#06B6D4',
    short: 'Peptyd regeneracyjny - kontuzje, stawy, ścięgna.',
    description: 'Body Protection Compound 157 to peptyd o wybitnym działaniu regeneracyjnym na tkanki miękkie.',
    benefits: ['Regeneracja ścięgien', 'Gojenie ran', 'Ochrona żołądka', 'Mniej bólu stawów']
  },
  {
    id: 'methandienone',
    name: 'Methandienone (Methanion)',
    category: 'tab',
    price: 80.00,
    oldPrice: null,
    dosage: '100 tab / 10mg',
    badge: null,
    image: `${IMG}/2021/11/Methandienone-500x500.png`,
    color: '#2563EB',
    short: 'Klasyczny Dianabol w tabletkach - szybki start masy.',
    description: 'Methandrostenolon to jeden z pierwszych anabolików doustnych. Daje szybki, dynamiczny przyrost masy i siły.',
    benefits: ['Szybki przyrost masy', 'Wybuchowa siła', 'Lepsze ukrwienie', 'Świetny kickstart cyklu']
  },
  {
    id: 'stanozolol',
    name: 'Stanozolol (Winstrol)',
    category: 'tab',
    price: 94.99,
    oldPrice: null,
    dosage: '100 tab / 10mg',
    badge: null,
    image: `${IMG}/2021/11/Stanazolol-500x500.png`,
    color: '#1D4ED8',
    short: 'Winstrol - klasyk redukcji w tabletkach.',
    description: 'Stanozolol nadaje mięśniom twardość i estetyczny wygląd. Nie aromatyzuje.',
    benefits: ['Twardość mięśni', 'Brak aromatyzacji', 'Wzrost siły bez masy', 'Estetyczna sylwetka']
  },
  {
    id: 'oxandrolone',
    name: 'Oxandrolone (Anavar)',
    category: 'tab',
    price: 180.00,
    oldPrice: null,
    dosage: '100 tab / 10mg',
    badge: 'Premium',
    image: `${IMG}/2021/11/Oxandrolone-500x500.png`,
    color: '#3B82F6',
    short: 'Anavar - łagodny i bezpieczny środek na rzeźbę.',
    description: 'Oxandrolone to delikatny steryd doustny o wysokim profilu bezpieczeństwa. Popularny wśród kobiet.',
    benefits: ['Łagodny profil', 'Bezpieczny dla kobiet', 'Twarda jakość', 'Wzrost siły']
  },
  {
    id: 'turinabol',
    name: 'Turinabol',
    category: 'tab',
    price: 120.00,
    oldPrice: 130.00,
    dosage: '100 tab / 10mg',
    badge: 'Promocja',
    image: `${IMG}/2021/11/Turinabol-500x500.png`,
    color: '#0EA5E9',
    short: 'Sucha masa i siła bez retencji wody.',
    description: 'Chlorodehydrometylotestosteron daje czystą, suchą masę i wzrost siły bez efektów estrogenowych.',
    benefits: ['Sucha masa', 'Wzrost siły', 'Brak retencji wody', 'Brak aromatyzacji']
  },
  {
    id: 'deca',
    name: 'Deca Durabolin',
    category: 'inj',
    price: 124.99,
    oldPrice: 135.00,
    dosage: '10ml / 250mg/ml',
    badge: 'Promocja',
    image: `${IMG}/2021/11/Deca-Durabolin-500x500.png`,
    color: '#1D4ED8',
    short: 'Nandrolon dekanonian - klasyk masy i regeneracji stawów.',
    description: 'Nandrolone Decanoate to długi ester nandrolonu znany ze świetnego wpływu na stawy i przyrost masy.',
    benefits: ['Regeneracja stawów', 'Wzrost masy', 'Lepsze samopoczucie', 'Wzrost kolagenu']
  },
  {
    id: 'clomid',
    name: 'Clomid (Virtufen)',
    category: 'sup',
    price: 70.00,
    oldPrice: null,
    dosage: '30 tab / 50mg',
    badge: null,
    image: `${IMG}/2021/11/Clomid-500x500.png`,
    color: '#0284C7',
    short: 'Klasyczny SERM do terapii odblokowującej (PCT).',
    description: 'Klomifen to selektywny modulator receptora estrogenowego. Standard w PCT i odbudowie własnego testosteronu.',
    benefits: ['Skuteczna PCT', 'Odbudowa testosteronu', 'Sprawdzona substancja', 'Łagodny profil']
  },
  {
    id: 'hcg',
    name: 'HCG 5000IU',
    category: 'sup',
    price: 69.99,
    oldPrice: 80.00,
    dosage: '5000IU',
    badge: 'Promocja',
    image: `${IMG}/2021/11/HCG-500x500.png`,
    color: '#0369A1',
    short: 'Gonadotropina kosmówkowa - utrzymanie funkcji jąder w cyklu.',
    description: 'HCG naśladuje LH i utrzymuje produkcję testosteronu w jądrach podczas długich cykli.',
    benefits: ['Ochrona jąder', 'Lepsze PCT', 'Utrzymanie libido', 'Płodność']
  }
];

export const HERO_SLIDES = [
  {
    id: 1,
    title: 'Sterydy najwyższej jakości',
    subtitle: 'Najlepsze marki, sprawdzone laboratoria, dyskretna wysyłka.',
    cta: 'Przeglądaj sklep',
    accent: 'Nowa kolekcja 2026',
    image: `${IMG}/2026/04/ChatGPT-Image-25-kwi-2026-03_05_36.png`
  },
  {
    id: 2,
    title: 'Peptydy i HGH klasy farmaceutycznej',
    subtitle: 'Tirzepatide, BPC-157, GHK-Cu, HGH - sprawdzona czystość.',
    cta: 'Zobacz peptydy',
    accent: 'Wysoka czystość',
    image: `${IMG}/2026/04/ChatGPT-Image-25-kwi-2026-03_07_06.png`
  },
  {
    id: 3,
    title: '100% Anonimowość zakupów',
    subtitle: 'Kontakt przez Telegram, brak danych na stronie, szybka wysyłka.',
    cta: 'Skontaktuj się',
    accent: 'Bezpieczne zakupy',
    image: `${IMG}/2026/04/ChatGPT-Image-25-kwi-2026-03_08_14.png`
  }
];

export const FEATURES = [
  {
    icon: 'Award',
    title: 'Najlepsze marki',
    text: 'Nasze sterydy, anaboliki i suplementy są przechowywane w optymalnych warunkach, aby zachować pełną aktywność substancji czynnych. Dla nas liczy się jak najlepsza jakość dla Klienta.'
  },
  {
    icon: 'ShieldCheck',
    title: 'Pełna anonimowość',
    text: 'Po zdecydowaniu się na produkt skontaktuj się z nami przez Telegram, aby nie pozostawić na stronie żadnych danych. Cenimy pełną dyskrecję i prywatność naszych klientów.'
  },
  {
    icon: 'Truck',
    title: 'Ekspresowa wysyłka',
    text: 'Produkty wysyłamy po zapłacie najszybciej jak to możliwe. Klient może poinformować o ewentualnym późniejszym wysłaniu paczki, jeśli nie będzie miał możliwości jej wcześniejszego odebrania.'
  },
  {
    icon: 'BadgeCheck',
    title: 'Oryginalne produkty',
    text: 'Każdy produkt pochodzi bezpośrednio od producenta. Sprawdzona seria, oryginalne opakowania i kody weryfikacyjne na życzenie klienta.'
  }
];

export const TESTIMONIALS = [
  { name: 'Marek W.', role: 'Klient od 2 lat', text: 'Świetny kontakt, ekspresowa wysyłka i jakość na najwyższym poziomie. Polecam każdemu.', rating: 5 },
  { name: 'Tomasz K.', role: 'Stały klient', text: 'Sprawdzone produkty, dyskretne pakowanie i pełna anonimowość. Lepszego sklepu nie znajdziecie.', rating: 5 },
  { name: 'Patryk Z.', role: 'Klient', text: 'Po pierwszym zamówieniu wiedziałem, że wrócę. Wszystko zgodnie z opisem.', rating: 5 }
];
